import React, { useEffect, useRef, useState } from "react";

import StepIndicator from './StepIndicator'
import "./BybBrewingProcess.css"
// import stepindicator from "../../assets/images/stepindicator.svg"
function FourDProcess() {

  
  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  return (
   <>
   <section className='new_byb byb-bgps' style={{backgroundColor:"rgb(7, 26, 40)"}}>
<div className='container'>
<div className='byb-bgps-header'>
<h2 ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}>The 4D Process at a Glance </h2>
<p className="p_txt">As a community we believe in the 4D Process as a <span style={{ color: "white" }}> holistic approach that marries strategy with soul, art with science and brands with their customers. </span>
            </p>
</div>


<div className='res-stepone-main four_d'>


<div className='byb-bgps-stepone'>
<h5>Discover</h5>
<div className='byb-bgps-stepone-content'>
  <div className='byb-bgps-stepone-contentleft'>
  {/* <h2>Assess Your Brand</h2> */}
  <p>Uncover the market landscape, audience behaviours, and real-world data that inform compelling strategies</p>
  </div>
  <div className='byb-bgps-stepone-contentright'>
   <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d1.svg" alt="Discover process step visual" />
  </div>
</div>
</div>


<div className='byb-bgps-stepone'>
<h5>Define </h5>
<div className='byb-bgps-stepone-content'>
  <div className='byb-bgps-stepone-contentleft'>
  {/* <h2>Analyse Findings</h2> */}
  <p>Translating insights into a clear brand purpose, identity, and positioning that guide every future decision. </p>
  </div>
  <div className='byb-bgps-stepone-contentright'>
   <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d2.svg" alt="Define process step visual" />
  </div>
</div>
</div>



<div className='byb-bgps-stepone'>
<h5>Develop</h5>
  <div className='byb-bgps-stepone-content'>
    <div className='byb-bgps-stepone-contentleft'>
    {/* <h2>Assess your brand</h2> */}
    <p>Collaboration across disciplines to turn ideas into tangible deliverables—such as visual identities, campaigns, and content. </p>
    </div>
    <div className='byb-bgps-stepone-contentright'>
    <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d3.svg" alt="Develop process step visual" />
    </div>
  </div>
</div>


<div className='byb-bgps-stepone'>
<h5>Deliver </h5>
  <div className='byb-bgps-stepone-content'>
    <div className='byb-bgps-stepone-contentleft'>
    {/* <h2>Assess your brand</h2> */}
    <p>Executing plans, measuring outcomes, and refining ongoing impact and relevance in the marketplace. </p>
    </div>
    <div className='byb-bgps-stepone-contentright'>
    <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/d4.svg" alt="Deliver process step visual" />
    </div>
  </div>
</div>

</div>




<StepIndicator/>
</div>
   </section>
   
   </>
  )
}

export default FourDProcess
